import mug from "../../assets/img/mug.png";
import cap from "../../assets/img/cap.png";
import car from "../../assets/img/car.png";
import tshirt from "../../assets/img/t-shirt.png";
import bagg from "../../assets/img/paperBag2.jpg";
import rollUp from "../../assets/img/rollUp.png";
import invoice from "../../assets/img/invoice.png";
import profile from "../../assets/img/profile.png";
import flexSAV from "../../assets/img/flexSAV.png";
import flyerPoster from "../../assets/img/flyerPoster.png";
import businessCard from "../../assets/img/businessCard.png";
import jotter from "../../assets/img/jotter.png";
//import meter1 from "../../assets/img/meter1.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
//import arrow1 from "../../assets/img/arrow1.svg";
//import arrow2 from "../../assets/img/arrow2.svg";
import colorSharp from "../../assets/img/color-sharp.png"

export const Sample = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="samples">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Samples</h2><br />
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={cap} alt="art" />
                                <h6 className='pic-label'>Face Cap</h6>
                                <small>Design/Branding</small>
                            </div>
                            <div className="item">
                                <img src={mug} alt="art" />
                                <h6 className='pic-label'>Mug</h6>
                                <small>Design/Branding</small>
                            </div>
                            <div className="item">
                                <img src={jotter} alt="art" />
                                <h6 className='pic-label'>Jotter/Programme</h6>
                                <small>Design/Printing</small>
                            </div>
                            <div className="item">
                                <img src={bagg} alt="art" />
                                <h6 className='pic-label'>Paper Bag</h6>
                                <small>Design/Printing</small>
                            </div>
                            <div className="item">
                                <img src={flyerPoster} alt="art" />
                                <h6 className='pic-label'>Flyers & Posters</h6>
                                <small>Design/Printing</small>
                            </div>
                            <div className="item">
                                <img src={flexSAV} alt="art" />
                                <h6 className='pic-label'>Flex/SAV</h6>
                                <small>Design/Printing</small>
                            </div>
                            <div className="item">
                                <img src={rollUp} alt="art" />
                                <h6 className='pic-label'>Roll-Up Stand</h6>
                                <small>Design/Printing/mountain</small>
                            </div>
                            <div className="item">
                                <img src={businessCard} alt="art" />
                                <h6 className='pic-label'>Business Card</h6>
                                <small>Design/Printing</small>
                            </div>
                            <div className="item">
                                <img src={car} alt="art" />
                                <h6 className='pic-label'>Vehicle Branding</h6>
                                <small>Design/Branding</small>
                            </div>
                            <div className="item">
                                <img src={tshirt} alt="art" />
                                <h6 className='pic-label'>T-Shirt Branding</h6>
                                <small>Design/Branding</small>
                            </div>
                            <div className="item">
                                <img src={invoice} alt="art" />
                                <h6 className='pic-label'>Receipt/Invoice/Waybills</h6>
                                <small>Design/Printing/Finishing</small>
                            </div>
                            <div className="item">
                                <img src={profile} alt="art" />
                                <h6 className='pic-label'>Company Profile</h6>
                                <small>Design/Printing</small>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="art" />
    </section>
  )
}
